import {
    GetCurrentTaxpayerResponseDto,
    UpdateCompanyProfileRequest,
    RegisterDelegateDto,
    RepresentationInvitationModel,
    UpdateSystemDelegateResponseDto,
    UserStatusUpdateDto,
} from '../../Services/ClientProxy/clientProxy';
import {
    GetUserPreferenceResponse,
    RecipientPreferenceRequestDto
} from '../../Services/ClientProxy/NotificationManagementClient';

export const LOAD_TAXPAYER_PROFILE = 'LOAD_TAXPAYER_PROFILE';
export const LOAD_TAXPAYER_NOTIFICATIONS = 'LOAD_TAXPAYER_NOTIFICATIONS';
export const UPDATE_TAXPAYER_PROFILE = 'UPDATE_TAXPAYER_PROFILE';
export const UPDATE_TAXPAYER_NOTIFICATIONS = 'UPDATE_TAXPAYER_NOTIFICATIONS';
export const INVITE_USER = 'INVITE_USER';
export const EDIT_ERPSYSTEM = 'EDIT_ERPSYSTEM';
export const ADDERP_SYSTEM = 'ADDERP_SYSTEM';
export const BLOCK_USER = 'BLOCK_USER';

export interface LoadTaxpayerProfileAction {
    type: typeof LOAD_TAXPAYER_PROFILE;
    payload: GetCurrentTaxpayerResponseDto;
}

export interface LoadTaxpayerNotificationsAction {
    type: typeof LOAD_TAXPAYER_NOTIFICATIONS;
    payload: GetUserPreferenceResponse;
}

export interface UpdateTaxpayerProfileAction {
    type: typeof UPDATE_TAXPAYER_PROFILE;
    payload: UpdateCompanyProfileRequest;
}

export interface UpdateTaxpayerNotificationsAction {
    type: typeof UPDATE_TAXPAYER_NOTIFICATIONS;
    payload: RecipientPreferenceRequestDto;
}

export interface InviteUserAction {
    type: typeof INVITE_USER;
    payload: RegisterDelegateDto;
}

export interface AddErpSystemAction {
    type: typeof ADDERP_SYSTEM;
    payload: RepresentationInvitationModel;
}

export interface EditErpSystem {
    type: typeof EDIT_ERPSYSTEM;
    payload: UpdateSystemDelegateResponseDto;
}

export interface BlockUserAction {
    type: typeof BLOCK_USER;
    payload: UserStatusUpdateDto;
}

export type TaxpayerProfileActionTypes =
    | LoadTaxpayerProfileAction
    | UpdateTaxpayerProfileAction
    | LoadTaxpayerNotificationsAction
    | UpdateTaxpayerNotificationsAction
    | InviteUserAction
    | AddErpSystemAction
    | EditErpSystem
    | BlockUserAction;
